module.exports = __webpack_public_path__ + "img/bg.55a91c1c.webp";